import * as React from 'react';
import Popover from '@mui/material/Popover';
import { Button } from 'common/button'
import './index.scss'
import {Text} from "../../../../common/text";

export default function BasicPopover({ ...props }) {
  const { disabled } = props
  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? 'simple-popover' : undefined;

  return (
    <div>
      <Button
        appearance={props.item?.appearance}
        icon={props.item?.icon}
        onClick={handleClick}
        aria-describedby={id}
        variant="contained"
        iconPosition="front"
        disabled={disabled}
      >
        {props.item?.name}
      </Button>
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        sx={{
          color: 'success.dark',
          display: 'inline',
          fontWeight: 'bold',
          mx: 0.5,
          fontSize: 14,
          top: 4
        }}
      >
        <ul className="common-popover-invoice__selected-action-menu">
          {props.item?.items?.map((item, index) => (
            <li
              className="common-popover-invoice__selected-action-menu-item"
              key={index}
            >
                <Text onClick={()=>{
                    item.action()
                    handleClose()
                }}>{item.name}</Text>
            </li>
          ))}
        </ul>
      </Popover>
    </div>
  );
}
